import { createFileRoute } from "@tanstack/react-router";
import { ConnectorCreateForm } from "@/components/portal/connectors/ConnectorCreateForm";

export const Route = createFileRoute("/portal/connectors/sqlserver/new")({
  component: NewSqlConnectorPage,
});

function NewSqlConnectorPage() {
  return <ConnectorCreateForm typeSlug="sqlserver" />;
}
